import styled from 'styled-components';

export const Container = styled.div`
  background: #f9f9fb 0% 0% no-repeat padding-box;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CreateAccountBox = styled.div`
  border: 1px solid #dfdfe6;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 8px;
  opacity: 1;
  padding: 30px 20px;
  width: 720px;
`;

export const Header = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

export const ImageContainer = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
`;

export const CreateAccountContainer = styled.div``;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const DataInput = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const FirstInput = styled.div`
  display: flex;
  width: 100%;
`;

export const LastInput = styled.div`
  display: flex;
  width: 100%;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  height: 90px;
  width: 100%;
`;
export const Label = styled.label`
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #2e384d;
  text-transform: uppercase;
  opacity: 1;
  margin-bottom: 8px;
  margin-left: 5px;
`;
export const Input = styled.input`
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #dfe3e8;
  border-radius: 4px;
  opacity: 1;
  height: 45px;
  font-size: 14px;
  letter-spacing: 0px;
  color: #6b7786;
  opacity: 1;
  padding-left: 16px;
  margin: 0 5px;
`;

export const ButtonCreateAccount = styled.button`
  width: 335px;
  height: 40px;
  background: #2699fb 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
  border: none;
  color: #fff;
  font-size: 12px;
  opacity: 1;
  font-weight: 600;
  margin-top: 16px;
`;

export const Title = styled.h2`
  font-size: 22px;
  font-weight: normal;
  text-align: center;
  margin-bottom: 20px;
`;

export const InputError = styled.p`
  font-size: 11px;
  color: red;
  text-align: left;
`;

export const Backto = styled.a`
  margin-top: 8px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #2493eb;
  opacity: 1;
  cursor: pointer;
`;
